module.exports = __webpack_public_path__ + "static/media/oldman.5f64ec8a.jpeg";